import capitalize from 'lodash/capitalize';
import { LeaveRequestsStatusCategoriesEnum } from '../../../../../core/enums/dictionariesEnums';

export const leaveRequestsStatusCategories = Object.values(LeaveRequestsStatusCategoriesEnum).map((el) => ({
  label: capitalize(el),
  value: el,
}));
